<div class="flex-col max-width-lg white-bg mb-18 mt-64">
  <div class="flex flex-row mb-60">
    <div class="flex-col mr-104">
      <div *ngIf="service?.punchline" class="mat-headline-4 fw-600 mb-24">{{ service?.punchline }}</div>
      <div class="mat-body-2 mb-28">{{ service?.shortDescription }}</div>
      <div *ngIf="capabilitiesGroups">
        <div *ngFor="let capabilitiesGroup of capabilitiesGroups" class="mat-headline-5 fw-700 mb-14">
          {{capabilitiesGroup.capabilities.length}} {{capabilitiesGroup.name === CapabilityType.MANDATORY ?
          ('CAPABILITIES.INCLUDED_CAPABILITIES' | transloco) : ('CAPABILITIES.OPTIONAL_CAPABILITIES' | transloco)}}
        </div>
      </div>
    </div>
    <div *ngIf="marketingMedia; else defaultImage" class="marketing-media cursor-pointer" (click)="openVideo()">
      <app-play-button></app-play-button>
      <img [src]="marketingMedia.iconHref">
    </div>
    <ng-template #defaultImage>
      <img *ngIf="marketingMedia" [src]="marketingMedia.iconHref">
    </ng-template>
    <ng-template #defaultVideo>
      <iframe width="840" height="350" src="https://www.youtube.com/embed/jUxGj6kbEE8" title="YouTube video player"
        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </ng-template>
  </div>
  <div class="fw-700 mat-subtitle-1 mb-12">{{service.tagline}}</div>
  <div class="fw-500 mb-34 primary-fg fs-16" [innerHTML]="service?.longDescription"></div>
</div>

<div *ngIf="capabilitiesGroups?.length > 0" class="max-width-lg capabilities-bg-gradient w-100-percent pt-74 pb-40">
  <div class="flex-row">
    <div class="flex-col">
      <div class="mat-headline-4 fw-600 mb-24">{{service.name}} Capabilities </div>
      <div class="fw-500 mat-subtitle-2">
        These are the capabilities that are included in the {{service.name | titlecase}} package for
        {{service.lineOfBusiness[0] | titlecase}}. <br>
      </div>
    </div>
    <div *ngIf="permissionsMap[Permission.DOWNLOAD_IAC]"
      class="flex flex-row justify-center items-center cursor-pointer p-16 estimate-btn w-250 h-48 ml-auto" (click)="downloadSetup()">
      <mat-icon svgIcon="file_download" class="icon-sm mr-10"></mat-icon>
      <div class="fw-700"> {{ "IAC_DOWNLOAD.DOWNLOAD_IAC" | transloco }}
      </div>
    </div>
  </div>
  <ng-container *ngFor="let capabilitiesGroup of capabilitiesGroups">
    <div class="mat-headline-5 fw-700 mb-24 mt-28">
      {{capabilitiesGroup.name === CapabilityType.MANDATORY ? ('CAPABILITIES.INCLUDED_CAPABILITIES' | transloco) :
      ('CAPABILITIES.OPTIONAL_CAPABILITIES' | transloco)}}
      {{capabilitiesGroup.capabilities ? '(' + capabilitiesGroup.capabilities.length + ')' : ''}}
    </div>
    <div>
      <div class="flex flex-wrap ml--12 mr--12">
        <ng-container *ngFor="let capability of capabilitiesGroup.capabilities">
          <div class="pl-12 pr-12 mb-24 w-25-percent">
            <app-capability-card [capability]="capability" [capabilityDescription]="capabilityDescription"
              [selectable]="capability.required === CapabilityType.OPTIONAL"
              (selectionChanged)="selectionChanged($event)" [isUpdated]="isUpdated(capability)"></app-capability-card>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<div *ngIf="updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE]" class="max-width-lg white-bg mt-64">
  <div class="flex-col">
    <div class="flex-row" class="mb-24 pl-0">
      <div class="mat-headline-5 fw-600">{{service.name}}</div>
    </div>
    <mat-divider class="w-100-percent mb-28"></mat-divider>
    <div class="flex flex-col hidden">
      <div class="flex-row">
        <div class="flex-col">
          <div class="mat-headline-5 fw-700 mb-16">{{ "SOLUTION_SUMMARY.ESTIMATED_COST" | transloco }}</div>
          <div class="mat-subtitle-2 fw-500">
            {{ "SOLUTION_SUMMARY.PRICE_DESCRIPTION" | transloco }}
          </div>
        </div>
        <div class="flex flex-row justify-center items-center cursor-pointer p-16 estimate-btn w-250 h-48 ml-auto disabled">
          <mat-icon svgIcon="file_download" class="icon-sm mr-10"></mat-icon>
          <div class="fw-700"> {{ "SOLUTION_SUMMARY.DOWNLOAD_ESTIMATE" | transloco }}
          </div>
        </div>
      </div>
    </div>

    <div class="mt-24">
      <!-- <div class="flex flex-col summary-footer p-24">
        <div class="flex flex-row">
          <img class="w-32 h-32" src="/assets/images/online-sandbox.png">
          <div class="mat-headline-6 fw-700 ml-18 mb-0">{{ "SOLUTION_SUMMARY.SANDBOX.SANDBOX" | transloco }}</div>
        </div>

        <mat-divider class="w-100-percent mb-16 mt-12"></mat-divider>
        <ul class="mat-subtitle-2 fw-400">
          <li>{{ "SOLUTION_SUMMARY.SANDBOX.SANDBOX_DESCRIPTION_1" | transloco }}</li>
          <li>{{ "SOLUTION_SUMMARY.SANDBOX.SANDBOX_DESCRIPTION_2" | transloco }}</li>
          <li>{{ "SOLUTION_SUMMARY.SANDBOX.SANDBOX_DESCRIPTION_3" | transloco }}</li>
          <li> {{ "SOLUTION_SUMMARY.SANDBOX.SANDBOX_DESCRIPTION_4" | transloco }}</li>
        </ul>

        <div class="button-container w-100-percent">
          <div class="spinner-container" *ngIf="sandboxLoader">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
          <div *ngIf="!instanceId|| !blueprintId">
            <button *ngIf="hasCreateSandboxPermission" class="white w-100-percent mt-auto blend-border service-letter-spacing"
              [disabled]="displayStartFreeTrialButton || !hasCreateSandboxPermission" [ngClass]="{'sandbox-text-disabled': sandboxLoader}" (click)="onOpenSandbox()">{{
              'SOLUTION_SUMMARY.SANDBOX.CREATE_SANDBOX' |
              transloco }}</button>
          </div>

        </div>

      </div> -->
      <div class="flex flex-col summary-footer p-24">
        <div class="flex flex-row">
          <img class="w-32 h-32" src="/assets/images/My services.png">
          <div class="mat-headline-6 fw-700 ml-18 mb-0">{{ 'SOLUTION_SUMMARY.ENTERPRISE.ENTERPRISE' | transloco }}</div>
          <div class="estimated-cost-per-month ml-auto mr-56 fw-600"><span class="fw-400 ml-4"></span></div>
        </div>

        <mat-divider class="w-100-percent mb-16 mt-12"></mat-divider>
        <ul class="mat-subtitle-2 fw-400">
          <li>Creating a service allows you to access the path-to-live journey in the Banking Cloud
          </li>
          <li>The platform saves your choices automatically also as a template</li>
          <li>To avail the enterprise service click on contact sales button below</li>
        </ul>
        <span class="flex-auto"></span>
        <button *ngIf="(UpdateExtendService && !instanceId); else showCreateButton"
          class="primary w-100-percent mt-auto blend-border service-letter-spacing"
          [disabled]="selectedCapabilitiesArr.length === 0 || blueprint !== false"
          [ngClass]="{'update-opacity': selectedCapabilitiesArr.length === 0  || blueprint !== false}"
          (click)="updateService()"> {{ 'SOLUTION_SUMMARY.ENTERPRISE.UPDATE_SERVICE' | transloco }}</button>
        <ng-template #showCreateButton>
          <button *ngIf="updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE]" class="primary w-25-percent mt-auto max-blend-border service-letter-spacing" type="button"
            (click)="updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE] ? setupService() : ''" [disabled]="(instanceId && blueprintId) || !updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE]"
            [ngClass]="{'update-opacity': (instanceId && blueprintId) || !updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE]}">{{ 'SOLUTION_SUMMARY.ENTERPRISE.CREATE_SERVICE'
            | transloco }}
          </button>
        </ng-template>

      </div>
    </div>
  </div>
</div>

<!-- <div class="max-width-lg white-bg mb-64">
  <app-faq></app-faq>
</div> -->

<!-- <div class="max-width-lg white-bg mt-64">
  <div class="ecosystem">
    <div class="mat-headline-4 fw-600 mb-40 primary-fg">{{ "SOLUTION_SUMMARY.COMMUNITY.ECOSYSTEM" | transloco }}</div>
    <div class="flex-row content pl-0">
      <div class="flex-col description pl-64 pr-64">
        <div class="fw-600 mb-20 white-fg mat-headline-3">{{ "SOLUTION_SUMMARY.COMMUNITY.TITLE" | transloco }}</div>
        <div class="white-fg mat-body-1 fw-500 mb-30">{{ "SOLUTION_SUMMARY.COMMUNITY.DESCRIPTION" | transloco }}</div>
        <button class="w-max-content transparent-btn max-blend-border white-fg" type="button">
          <div class="flex flex-row justify-center items-center">
            <mat-icon svgIcon="open_in_new" class="icon-sm mr-8"></mat-icon>
            <a class="external-link pt-8" href="https://basecamp.temenos.com/s/" target="_blank">{{
              "SOLUTION_SUMMARY.COMMUNITY.FIND_MORE_BUTTON" | transloco }}</a>
          </div>
        </button>
      </div>
    </div>
  </div>
</div> -->
